import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth-context";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Fleet from "@/pages/Fleet";
import VehicleDetail from "@/pages/VehicleDetail";
import Leases from "@/pages/Leases";
import Drivers from "@/pages/Drivers";
import Workshop from "@/pages/Workshop";
import ServiceOrderDetail from "@/pages/ServiceOrderDetail";
import History from "@/pages/History";
import Settings from "@/pages/Settings";
import Verify from "@/pages/Verify";
import Alertas from "@/pages/Alertas";
import Reports from "@/pages/Reports";
import Admin from "@/pages/Admin";
import Insights from "@/pages/Insights";
import MaintenanceIntervals from "@/pages/MaintenanceIntervals";
import Companies from "@/pages/Companies";
import UsersPage from "@/pages/Users";
import WorkshopCalendar from "@/pages/WorkshopCalendar";
import BookingCreate from "@/pages/BookingCreate";
import MyBookings from "@/pages/MyBookings";
import { Toaster } from "sonner";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-gray-500">Cargando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" />
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
            <Route path="/verify/:id" element={<Verify />} />

            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/flota" element={<ProtectedRoute><Fleet /></ProtectedRoute>} />
            <Route path="/flota/:id" element={<ProtectedRoute><VehicleDetail /></ProtectedRoute>} />
            <Route path="/contratos" element={<ProtectedRoute><Leases /></ProtectedRoute>} />
            <Route path="/conductores" element={<ProtectedRoute><Drivers /></ProtectedRoute>} />
            <Route path="/empresas" element={<ProtectedRoute><Companies /></ProtectedRoute>} />
            <Route path="/usuarios" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
            <Route path="/taller" element={<ProtectedRoute><Workshop /></ProtectedRoute>} />
            <Route path="/taller/orden/:id" element={<ProtectedRoute><ServiceOrderDetail /></ProtectedRoute>} />
            <Route path="/historial" element={<ProtectedRoute><History /></ProtectedRoute>} />
            <Route path="/alertas" element={<ProtectedRoute><Alertas /></ProtectedRoute>} />
            <Route path="/insights" element={<ProtectedRoute><Insights /></ProtectedRoute>} />
            <Route path="/mantenciones" element={<ProtectedRoute><MaintenanceIntervals /></ProtectedRoute>} />
            <Route path="/calendario" element={<ProtectedRoute><WorkshopCalendar /></ProtectedRoute>} />
            <Route path="/agendar" element={<ProtectedRoute><BookingCreate /></ProtectedRoute>} />
            <Route path="/mis-reservas" element={<ProtectedRoute><MyBookings /></ProtectedRoute>} />
            <Route path="/reportes" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            <Route path="/configuracion" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
